//const base_url = 'http://localhost:8080'
const base_url = 'https://swallet.butonkab.go.id'

export { base_url }